import React, { type FormEvent, type FunctionComponent, useContext } from 'react'
import { CharityReviewContext } from '../../../../../contexts'
import { type FormField, EditableData } from '../../../../../common'
import { charityValueMap } from '../../../common/charity'
import { hasCharityEditPermission } from '../../../../../../services/permission.service'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  title: string
  formFields: FormField[]
  initialValues: { [key: string]: any }
  onUpdate: (data: { [key: string]: any }) => void
  isUpdating: boolean
}

export const EditableApplicationSection: FunctionComponent<Props> = ({
  title,
  formFields,
  initialValues,
  onUpdate,
  isUpdating
}) => {
  const { charity, approvedSections, approveSection, withdrawSectionApproval, editingSection, setEditingSection } =
    useContext(CharityReviewContext)
  const isApproved = approvedSections.indexOf(title) !== -1
  const isEditMode = editingSection === title

  const editClicked = () => {
    setEditingSection(title)
  }

  const editCancelled = () => {
    setEditingSection('')
  }

  const onApprove = () => {
    approveSection(title)
  }

  const withdrawApproval = (e: FormEvent) => {
    e.preventDefault()
    withdrawSectionApproval(title)
  }

  return (
    <>
      <EditableData
        isUpdating={isUpdating}
        isEditMode={isEditMode}
        formFields={formFields}
        initialValues={initialValues}
        displayValueMap={charityValueMap}
        onEdit={editClicked}
        onUpdate={onUpdate}
        editCancelled={editCancelled}
      />

      {!isEditMode && charity.status === 'NEW' && hasCharityEditPermission() && (
        <div className="flex justify-end">
          <Button
            variant="destructive"
            className="mr-lg"
            aria-label={`Undo approval of ${title} section`}
            onClick={withdrawApproval}
            disabled={!isApproved}
          >
            Undo approval
          </Button>
          <Button
            variant="primary"
            aria-label={`Approve ${title} section`}
            onClick={e => {
              e.preventDefault()
              onApprove()
            }}
            disabled={isApproved}
          >
            Approve section
          </Button>
        </div>
      )}
    </>
  )
}
